/* @flow */

import { em } from 'polished';
import { twitterBlue, linkedInBlue } from '@braindate/ui/lib/token/palette';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    height: 'min-content',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    width: '100%',
    textAlign: 'left',
    color: ({ theme }: ThemeFunction) => theme.textColor,
  },
  icons: {
    display: 'flex',
    alignItems: 'center',
    gap: '25px',
  },
  iconButton: {
    stroke: 'none',
    border: ({ theme }: ThemeFunction) =>
      `1px solid ${theme.textColorTertiary}`,
    marginLeft: 0,

    '&:hover': {
      backgroundColor: 'transparent !important',
      border: ({ theme }: ThemeFunction) => `1px solid ${theme.accentColor}`,
    },
  },
  icon: {
    width: `${em(25)} !important`,
    height: `${em(25)} !important`,
  },
  twitter: {
    color: twitterBlue,
  },
  linkedIn: {
    color: linkedInBlue,
  },
  copy: {
    textAlign: 'left',
    margin: [32, 0],
    fontWeight: 600,
    fontSize: em(14),
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  input: {
    width: '100%',
    fontSize: `${em(12)} !important`,
  },
  adornment: {
    width: '90%',
    height: '90%',
  },
  error: {
    color: ({ theme }: ThemeFunction) => theme.errorMessageColor,
    fontWeight: 500,
    width: '100%',
    textAlign: 'left',
  },
};
